import { QuotaType } from 'dy-frontend-http-repository/lib/data/enums';

const quotaTypeInformation: { [quotaType in QuotaType]: string } = {
    [QuotaType.USER_ACTIVE_TASK]: 'Active requests',
    [QuotaType.USER_BACKLOG_TASK]: 'Backlog requests',
    [QuotaType.USER_BRAND_PROFILE]: 'Brand profiles',
    [QuotaType.USER_AI_IMG_PERIOD_TOKEN]: 'Max AI image tokens per-period',
    [QuotaType.USER_AI_TASK_BRIEF_PERIOD_RUNS]: 'Max AI request brief usage per-period',
    [QuotaType.USER_SPACE_MEMBER_COUNT]: 'Max team members',
};

export default quotaTypeInformation;
